import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React from 'react';
import PropTypes from 'prop-types';
import { INSURANCE_STATUSES } from './constants';
export var EditSocialInsuranceModalMessage = function EditSocialInsuranceModalMessage(_ref) {
  var insuranceStatus = _ref.insuranceStatus,
    planName = _ref.planName;
  switch (insuranceStatus) {
    case INSURANCE_STATUSES.pending_enrollment:
      return /*#__PURE__*/React.createElement("p", {
        className: "text-sm"
      }, "Your request to ", /*#__PURE__*/React.createElement("strong", null, "enroll"), " this client in the ", planName, " social care coverage plan is pending.");
    case INSURANCE_STATUSES.pending_disenrollment:
      return /*#__PURE__*/React.createElement("p", {
        className: "text-sm"
      }, "Your request to ", /*#__PURE__*/React.createElement("strong", null, "disenroll"), " this client from the ", planName, " social care coverage plan is pending.");
    case INSURANCE_STATUSES.enrolled:
      return /*#__PURE__*/React.createElement("p", {
        className: "text-sm"
      }, "This client is ", /*#__PURE__*/React.createElement("strong", null, "enrolled"), " in the ", planName, " social care coverage plan.");
    case INSURANCE_STATUSES.not_enrolled:
    case INSURANCE_STATUSES.rejected:
      return /*#__PURE__*/React.createElement("p", {
        className: "text-sm"
      }, "This client is ", /*#__PURE__*/React.createElement("strong", null, "not enrolled"), " in the ", planName, " social care coverage plan.");
    default:
      return '';
  }
};
EditSocialInsuranceModalMessage.propTypes = {
  insuranceStatus: PropTypes.oneOf(_Object$keys(INSURANCE_STATUSES)).isRequired,
  planName: PropTypes.string.isRequired
};
//# sourceMappingURL=EditSocialInsuranceModalMessage.js.map